import api from './config';
export default api;
